import React from "react";
import questionImg from "../../../assets/images/devis.png";

import "./index.scss";
import { FlechBtn } from "../../../assets/icons/FlechBtn";
export const DemandeDevis = ({ title }) => {
  return (
    <div className={`pourquoi-choisir `}>
      <div className="row align-items-center gx-0">
        {/* Colonne Image */}

        {/* Colonne Texte */}
        <div className="col-md-8  col-padding">
          <h2>{title}</h2>
          <div>
            {" "}
            <a class="btn-slide" href="/contact">
              <span class="circle">
                <FlechBtn />
              </span>

              <span class="title">Demander un devis gratuit</span>
              <span class="title title-hover">Demander un devis gratuit</span>
            </a>{" "}
          </div>
        </div>
        <div className="col-md-4 text-center image-container mb-4 mb-md-0 p-0">
          <img src={questionImg} alt="Point d'interrogation" />
        </div>
      </div>
    </div>
  );
};
